export default "__VITE_PUBLIC_ASSET__60b35fd5__"